import { AccountSettings } from "01Data/Account";
import { AppContext } from "01Data/AppData";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  IconButton,
  Toolbar,
  Typography,
  TypographyProps,
  styled,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

const MyAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

const MyToolBar = styled(Toolbar)(({ theme }) => ({
  paddingRight: 24,
}));

const MyIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: 36,
}));

const MyTypography = styled(Typography)<
  TypographyProps<"h1", { component: "h1" }>
>(({ theme }) => ({
  flexGrow: 1,
  wordBreak: "keep-all",
  overflowWrap: "anywhere",
}));

type Props = {
  open: boolean;
  setOpen: any;
};

const Header = (props: Props) => {
  const a = useContext(AppContext).account;
  const [name, setName] = useState("");
  const isSmartphone = useMediaQuery({
    query: "(max-width: 600px)",
  });

  useEffect(() => {
    a.GetAttributes()
      .then((settings: AccountSettings) => {
        setName(settings.lastName + settings.firstName);
      })
      .catch((err: any) => {
        console.log("ユーザー情報取得エラー");
        console.error(err);
        setName("");
      });
  }, [a]);

  const handleDrawerOpen = () => {
    props.setOpen(!props.open);
  };

  return (
    <MyAppBar position="sticky">
      <MyToolBar>
        <MyIconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
        >
          <MenuIcon />
        </MyIconButton>
        <MyTypography
          component="h1"
          variant={isSmartphone ? "body2" : "h6"}
          color="inherit"
          minWidth={150}
        >
          漏水みはり番
          <wbr />
          監視システム
        </MyTypography>
        <MyTypography
          component="h1"
          variant={isSmartphone ? "body2" : "h6"}
          color="inherit"
          align="right"
        >
          {name + " " + (a.IsUser() ? `(${a.kind})` : "")}
        </MyTypography>
      </MyToolBar>
    </MyAppBar>
  );
};

export default Header;
